import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LocaleKey } from 'utils';
import {
  Image,
} from 'components';
import { WhiteContainer } from 'containers';
import { instruments } from '../instruments';

import styles from '../styles.module.scss';

interface IVideoContainer {
  langBanner: string;
}

export const VideoContainer:FC<IVideoContainer> = ({ langBanner }) => {
  const { t } = useTranslation('tools');
  const language = langBanner || localStorage.getItem('lng') || LocaleKey.en;
  const baseUrl = 'https://storage.googleapis.com/eclipse-cdn';

  return (
    <div className={styles.instruments_content}>
      {instruments.map(({
        icon,
        title,
        video,
        videoFile,
      }) => (
        <WhiteContainer
          className={styles.instruments_item}
        >
          <a
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
            href={video[langBanner]}
            target="_blank"
            rel="noreferrer"
          >
            <Image
              url={icon}
              className={styles.instruments_img}
            />
          </a>
          <div className={styles.instruments_title}>
            {t(title, { lng: language })}
            {' '}
          </div>
          <div className={styles.instruments_btn_container}>
            <a
              href={`${baseUrl}/videos/${videoFile}${language}.mp4`}
              download
              target="_blank"
              rel="noreferrer"
              className={styles.instruments_btn}
            >
              {t('Instruments_saved_', { lng: language })}
            </a>
          </div>
        </WhiteContainer>
      ))}
    </div>
  );
};
